function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLivemapSearchresultItemLocation = function SvgLivemapSearchresultItemLocation(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    "data-name": "Location Name 1",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M22041.49-11625.226a27.146 27.146 0 0 1-2.75-3.153c-1.721-2.33-2.59-4.377-2.59-6.093a5.526 5.526 0 0 1 5.645-5.389 5.528 5.528 0 0 1 5.643 5.389c0 4.111-5.123 9.041-5.338 9.246a.447.447 0 0 1-.3.122.44.44 0 0 1-.31-.122zm-4.477-9.246a9.493 9.493 0 0 0 2.047 5.052 27.139 27.139 0 0 0 2.734 3.3 26.7 26.7 0 0 0 2.732-3.3 9.482 9.482 0 0 0 2.043-5.052 4.678 4.678 0 0 0-4.775-4.559 4.681 4.681 0 0 0-4.78 4.559zm4.775 3a2.991 2.991 0 0 1-2.07-.963 2.972 2.972 0 0 1-.8-2.136 3 3 0 0 1 .914-2.069 2.994 2.994 0 0 1 2.141-.847 2.991 2.991 0 0 1 2.1.9 2.985 2.985 0 0 1 .863 2.113 3.053 3.053 0 0 1-.93 2.131 3.051 3.051 0 0 1-2.146.874zm-2.064-2.938a2.169 2.169 0 0 0 2.176 2.108h.033a2.19 2.19 0 0 0 2.141-2.175 2.219 2.219 0 0 0-2.23-2.174h-.049a2.19 2.19 0 0 0-2.07 2.246z",
    "data-name": "Path 11622",
    style: {
      fill: "#4da5b5"
    },
    transform: "translate(-22032.148 11642.859)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z",
    "data-name": "Rectangle 4499",
    style: {
      fill: "none"
    }
  }));
};
export default SvgLivemapSearchresultItemLocation;